import { useCallback, type KeyboardEvent, type MouseEvent } from "react";
import type { TableRow } from "./TableRow";

import { isContainerInputTarget } from "../../utils/nestedInteractive";

// clickable 행/그리드 아이템의 클릭·키보드(Enter/Space) 활성화 핸들러.
// DataTable·DataGridView가 공유해 중복 로직과 드리프트를 막는다. 행 DOM 안에서 난, 중첩
// 컨트롤 위가 아닌 입력만 활성화한다.
export function useRowActivation<Row extends TableRow>(): {
  onActivateClick: (event: MouseEvent<HTMLElement>, row: Row) => void;
  onActivateKeyDown: (event: KeyboardEvent<HTMLElement>, row: Row) => void;
} {
  const onActivateClick = useCallback((event: MouseEvent<HTMLElement>, row: Row) => {
    if (!row.isRowClickable || !isContainerInputTarget(event.target, event.currentTarget)) {
      return;
    }
    row.onRowClick();
  }, []);

  const onActivateKeyDown = useCallback((event: KeyboardEvent<HTMLElement>, row: Row) => {
    if (!row.isRowClickable || (event.key !== "Enter" && event.key !== " ")) {
      return;
    }
    if (!isContainerInputTarget(event.target, event.currentTarget)) {
      return;
    }
    event.preventDefault();
    row.onRowClick();
  }, []);

  return { onActivateClick, onActivateKeyDown };
}
